module.exports = __webpack_public_path__ + "f3add610339babf141647fbc499be5d3.png";